import { j as o } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as t } from "../../../../IconBase-CxZyIWw2.js";
const a = s((r, e) => /* @__PURE__ */ o.jsx(
  t,
  {
    ref: e,
    ...r,
    image: (i) => /* @__PURE__ */ o.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...i,
        children: /* @__PURE__ */ o.jsx(
          "path",
          {
            fill: "currentColor",
            d: "M2.86 1A2 2 0 0 0 .951 3.597L2.45 8.389A3.72 3.72 0 0 0 5 10.863v.637a4.5 4.5 0 0 0 8.994.236A2 2 0 0 0 13 8a2 2 0 0 0-1.01 3.726A2.5 2.5 0 0 1 7 11.5v-.637A3.72 3.72 0 0 0 9.551 8.39l1.498-4.792A2 2 0 0 0 9.139 1H8v2h1.14L7.642 7.793a1.72 1.72 0 0 1-3.284 0L2.86 3H4V1z"
          }
        )
      }
    )
  }
));
a.displayName = "ProviderIcon";
export {
  a as ProviderIcon,
  a as default
};
//# sourceMappingURL=index.js.map
